<template>
  <div>
    <v-toolbar color="grey-lighten-3" density="compact">
      <v-tabs v-model="currentTab">
        <v-tab v-for="tab in tabs" :key="tab" :text="tab" :value="tab" />
      </v-tabs>
    </v-toolbar>

    <v-tabs-window :model-value="currentTab">
      <v-tabs-window-item value="roles">
        <RoleSettings />
      </v-tabs-window-item>
      <v-tabs-window-item value="planner-groups">
        <PlannerGroupSettings />
      </v-tabs-window-item>
      <v-tabs-window-item value="cost-centers">
        <CostCenterSettings />
      </v-tabs-window-item>
      <v-tabs-window-item value="asset-classes">
        <AssetClassSettings />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script setup lang="ts">
import RoleSettings from "@/components/settings/RoleSettings.vue";
import PlannerGroupSettings from "@/components/settings/PlannerGroupSettings.vue";
import CostCenterSettings from "@/components/settings/CostCentreSettings.vue";
import AssetClassSettings from "@/components/settings/AssetClassSettings.vue";
import { useFilterStore } from "@/store/filter";
import { ref } from "vue";

const filters = useFilterStore();
filters.hide();

const tabs = [
  "roles",
  "planner-groups",
  "cost-centers",
  "asset-classes",
] as const;
type Tab = (typeof tabs)[number];

const currentTab = ref<Tab>(tabs[0]);
</script>
